import React, { useState } from 'react';
import { STATUS_META } from './styles';

export const StatusEditor = ({ initial, choices, excludeIds = [], onSave, onCancel, busy, testPrefix }) => {
  const [status, setStatus] = useState(initial?.source_status || 'current');
  const [replacement, setReplacement] = useState(initial?.superseded_by || '');
  const [date, setDate] = useState(initial?.effective_date || '');
  const options = choices.filter((c) => !excludeIds.includes(c.id) && c.source_status !== 'replaced');
  const blocked = status === 'replaced' && !replacement;

  return (
    <div className="ss-edit" data-testid={`${testPrefix}-editor`}>
      <div className="ss-seg" role="radiogroup">
        {Object.entries(STATUS_META).map(([k, m]) => (
          <button key={k} type="button" style={{ '--c': m.color }} className={status === k ? 'on' : ''}
            onClick={() => setStatus(k)} data-testid={`${testPrefix}-status-${k}`}>
            {m.label}
          </button>
        ))}
      </div>
      {status === 'replaced' && (
        <label className="ss-field">
          Replaced by (the newer handbook)
          <select value={replacement} onChange={(e) => setReplacement(e.target.value)}
            data-testid={`${testPrefix}-replacement-select`}>
            <option value="">Choose the newer handbook…</option>
            {options.map((c) => <option key={c.id} value={c.id}>{c.title}</option>)}
          </select>
        </label>
      )}
      <label className="ss-field">
        Effective date (optional, shown on citations)
        <input type="date" value={date} onChange={(e) => setDate(e.target.value)}
          data-testid={`${testPrefix}-effective-date`} />
      </label>
      <div className="ss-actions">
        <button className="ss-primary" disabled={busy || blocked}
          onClick={() => onSave({
            status,
            superseded_by: status === 'replaced' ? replacement : null,
            // Single edit: '' clears the date. Bulk: empty leaves each date alone.
            effective_date: date || (initial ? '' : null),
          })}
          data-testid={`${testPrefix}-save`}>
          {busy ? 'Saving…' : 'Save'}
        </button>
        {onCancel && <button className="ss-ghost" onClick={onCancel} data-testid={`${testPrefix}-cancel`}>Cancel</button>}
      </div>
    </div>
  );
};
